import { ASSET_TYPE } from './reducers';

export const ASSET_LOAD_START = 'ASSET_LOAD_START';
export const ASSET_LOAD_SUCCESS = 'ASSET_LOAD_SUCCESS';
export const ASSET_LOAD_FAIL = 'ASSET_LOAD_FAIL';
export const ASSET_LOAD_RELOAD = 'ASSET_LOAD_RELOAD';
export const ASSET_LOAD_ABORT = 'ASSET_LOAD_ABORT';
export const ASSET_LOAD_END = 'ASSET_LOAD_END';
export const ASSET_FAILED_EXPLANATION = 'ASSET_FAILED_EXPLANATION';
export const ASSET_NOT_FOUND = 'ASSET_NOT_FOUND';

/**
 * Called when an asset starts loading. That is, when it's DOM element has
 * been mounted on the page.
 */
export function assetLoadStart(assetId, assetType, preload = false) {
    return { type: ASSET_LOAD_START, assetId, assetType, preload };
}

/**
 * Called when an asset is successfully loaded. For videos this doesn't mean
 * that the entire video has been downloaded, just enough data to start.
 */
export function assetLoadSuccess(assetId, assetType, preload = false) {
    return { type: ASSET_LOAD_SUCCESS, assetId, assetType, preload };
}

/**
 * Called when an asset fails to load. The watchAssetLoadFailGround or
 * watchAssetLoadFailCloud decides whether to try to reload or abort.
 */
export function assetLoadFail(assetId, assetType, assetURL, preload = false, error = null) {
    return { type: ASSET_LOAD_FAIL, assetId, assetURL, assetType, preload, error };
}

/**
 * Called when we decide to reload an asset.
 */
export function assetLoadReload(assetId, assetType, preload = false) {
    return { type: ASSET_LOAD_RELOAD, assetId, assetType, preload };
}

/**
 * Called when we decide not to reload an asset.
 */
export function assetLoadAbort(assetId, assetType, preload = false) {
    return { type: ASSET_LOAD_ABORT, assetId, assetType, preload };
}

/**
 * Called when the asset is unmmounted and we no longer need it loaded.
 */
export function assetLoadEnd(assetId, assetType, preload = false) {
    return { type: ASSET_LOAD_END, assetId, assetType, preload };
}

/**
 * Opens a dialog explaining that an asset has failed to load.
 * @param assetType: (see assets/reducers)
 */
export function assetFailedExplanation(assetType = ASSET_TYPE.IMAGE) {
    return { type: ASSET_FAILED_EXPLANATION, assetType };
}

/**
 * Opens a dialog explaining that a video has failed to load.
 */
export function videoFailedExplanation() {
    return assetFailedExplanation('video');
}

/**
 * Used when an asset is not found on the server
 */
export function assetNotFound(assetId, assetType, preload = false, error = null) {
    return { type: ASSET_NOT_FOUND, assetId, assetType, preload, error };
}
